<script setup lang="ts">
const props = defineProps({
  imageUrl: {
    type: String,
    required: false
  },
  videoUrl: {
    type: String,
    required: false
  }
});
</script>

<template>
  <div class="flex">
    <div class="md:w-48 w-32 md:h-64 h-48 pt-2 pl-2 flex-shrink-0" v-if="props.videoUrl">
      <video
        :src="props.videoUrl"
        class="w-full h-full object-cover object-top rounded-lg"
        autoplay
        muted
        loop
        playsinline
      />
    </div>
    <div class="flex-1 min-w-0">
      <div class="p-2 text-metal-400">
        <slot name="text"></slot>
      </div>
    </div>
  </div>
  <div class="px-2 pt-2">
    <slot name="alerts"></slot>
  </div>
  <div class="border-t border-metal-750 flex justify-end p-2 rounded-b footer-bar">
    <slot name="buttons"></slot>
  </div>
</template>

<style scoped lang="scss">
.footer-bar {
  background: linear-gradient(to right, theme('colors.metal.800'), theme('colors.metal.900'));
}
</style>